import { createContext, useContext } from "react";

/** Id of the OS window a component renders in; kept dependency-free so shared UI can read it without loading OsWindow. */
export const WindowIdContext = createContext<string | undefined>(undefined);

export const useWindowId = () => useContext(WindowIdContext);
